import React from 'react';
import BookingDashboard from '../components/Booking/BookingDashboard';

const Bookings: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Booking Management</h1>
        <p className="mt-2 text-sm text-gray-600">
          Manage all customer bookings, view details, and handle modifications
        </p>
      </div>
      
      <BookingDashboard />
    </div>
  );
};

export default Bookings;
